type Translate = (
  message: string,
  options: { context: string; count: number; skipped: number },
) => string;

const CONTEXT = 'toast after a bulk snooze skipped some tasks';

export function snoozePartialSuccessMessage(
  gt: Translate,
  count: number,
  skipped: number,
): string {
  if (count === 1 && skipped === 1) {
    return gt('Snoozed {count} task. {skipped} task could not be snoozed.', {
      context: CONTEXT,
      count,
      skipped,
    });
  }
  if (count === 1) {
    return gt('Snoozed {count} task. {skipped} tasks could not be snoozed.', {
      context: CONTEXT,
      count,
      skipped,
    });
  }
  if (skipped === 1) {
    return gt('Snoozed {count} tasks. {skipped} task could not be snoozed.', {
      context: CONTEXT,
      count,
      skipped,
    });
  }
  return gt('Snoozed {count} tasks. {skipped} tasks could not be snoozed.', {
    context: CONTEXT,
    count,
    skipped,
  });
}
